import { getFromStorage } from '../../utils/localStorage';
import { LOCALES } from '../i18n/constants';
import { STORAGE_KEY } from '../../constants/locale';

const defaultContext = {
  locale: getFromStorage(STORAGE_KEY) || LOCALES.ENGLISH,
};

export default defaultContext;
